var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"churn-description-popup"},[_c('churn-popup',{attrs:{"buttons":_vm.buttonOptions,"close-action":_vm.close},scopedSlots:_vm._u([{key:"popup-content",fn:function(){return [_c('churn-description-popup-content')]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6c1268","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/churn/ChurnDescriptionPopup.vue
// module id = null
// module chunks = 